const getFormattedContact = (
  {
    firstName,
    lastName,
    emailAddress,
    defaultCurrency,
    address1,
    address2,
    address3,
    address4,
    city,
    region,
    postalCode,
    country,
    attentionTo,
    salesDefaultAccountCode,
    trackingCategoryName,
    salesDefaultLineAmountType,
    legalName,
  },
  { usersHashMap, contactId, clientId },
) => {
  const contact = {
    'contactNumber': clientId,
    'accountNumber': clientId,
    'name': legalName,
    'firstName': firstName,
    'lastName': lastName,
    'emailAddress': emailAddress,
    'addresses': [
      {
        'addressType': 'STREET',
        'addressLine1': address1,
        'addressLine2': address2,
        'addressLine3': address3,
        'addressLine4': address4,
        'city': city,
        'postalCode': postalCode,
        'attentionTo': attentionTo,
        'country': country,
        'region': region,
      },
    ],
    'contactPersons': Object.values(usersHashMap).reduce((acc, user) => {
      acc.push({
        'firstName': user.firstName.value,
        'lastName': user.lastName.value,
        'emailAddress': user.email.value,
        'includeInEmails': user.includeInEmails.value,
      })

      return acc
    }, []),
    'defaultCurrency': defaultCurrency,
    'salesDefaultLineAmountType': salesDefaultLineAmountType,
    'trackingCategoryName': trackingCategoryName,
    'salesDefaultAccountCode': salesDefaultAccountCode.split(' ')[0],
  }

  if (contactId) {
    contact.contactID = contactId
  }
  return contact
}

export { getFormattedContact }
